<template>
    <div>
        <SpacingClassWrapper :padding-bottom="0" :margin-bottom="6" :margin-top="8">
            <FlexClassWrapper
                :justify-content="$mq | mq({
                    sm: '',
                    md: flexJustifyContent.spaceEvenly
                })"
            >
                <ul :class="swiperPaginationClasses">
                    <SpacingClassWrapper
                        v-for="(paginationItem, key) in swiperPagination"
                        :key="key"
                        :margin-right="0"
                    >
                        <SpacingClassWrapper :padding-bottom="0">
                            <li
                                :class="isActivePagination(key) && activePaginationClasses"
                                @click="$emit('indexChange', key)"
                                :id="`${paginationId}-${key}`"
                            >
                                <FlexClassWrapper
                                    :align-items="flexAlignItems.center"
                                    :justify-content="flexJustifyContent.center"
                                >
                                    <SpacingClassWrapper :padding-x="4" :padding-y="2">
                                        <Typography
                                            :variant="$mq | mq({
                                                sm: typographyVariants.caption,
                                                md: typographyVariants.body
                                            })"
                                            :color="typographyColors.dark"
                                            :weight="typographyWeights.bold"
                                        >
                                            {{ paginationItem }}
                                        </Typography>
                                    </SpacingClassWrapper>
                                </FlexClassWrapper>
                            </li>
                        </SpacingClassWrapper>
                    </SpacingClassWrapper>
                </ul>
            </FlexClassWrapper>
        </SpacingClassWrapper>
    </div>
</template>

<script>
// Components
import Typography from '../../components/Typography';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';
import FlexClassWrapper from '../../classWrappers/FlexClassWrapper';

// Types
import { flexJustifyContent, flexAlignItems } from '../../types/Flex.types';
import { typographyVariants, typographyColors, typographyWeights } from '../../types/Typography.types';

// Mixins
import styles from '../../mixins/styles.js';
import translations from '../../mixins/translations.js';

//Config data
import { paginationId } from '../../config/form';

export default {
    name: 'ResultsSwiperLayout',
    components: {
        // Class Wrappers
        SpacingClassWrapper,
        FlexClassWrapper,
        // Components
        Typography
    },
    mixins: [styles, translations],
    props: {
        activeIndex: {
            type: Number,
            default: 0
        },
        indexChange: {
            type: Function,
            default: () => {}
        }
    },
    data: function () {
        return {
            flexJustifyContent,
            flexAlignItems,
            typographyColors,
            typographyWeights,
            typographyVariants,
            paginationId
        }
    },
    computed: {
        swiperPagination: function () {
            return [
                this.t('results.tournamentPayouts.cardTitle'),
                this.t('results.chipDistribution.cardTitle'),
                this.t('results.blindStructure.cardTitle'),
            ];
        },
        swiperDividerClasses: function () {
            return [
                this.cssClasses.pcc__swiper__divider
            ]
        },
        swiperPaginationClasses: function () {
            return [
                this.cssClasses.pcc__swiper__pagination
            ];
        },
        activePaginationClasses: function () {
            return [
                this.cssClasses.pcc__swiper__pagination__active
            ];
        }
    },
    methods: {
        isActivePagination: function (paginationIndex) {
            return this.activeIndex === paginationIndex;
        }
    }
}
</script>
